module.exports = __webpack_public_path__ + "static/media/photo81.28a0b545.jpg";